import axios from "axios";

import { API_URLS } from "src/utils/API_URLS";
import { parseErrorMessages, showErrorToast } from "src/utils/methods";
import { SelectOption, Dictionary } from "src/types";

interface HandleUpdateDictionaryParams {
  data: Dictionary;
  catchCallback?: () => void;
}

export const handleUpdateDictionary = async ({
  data,
  catchCallback,
}: HandleUpdateDictionaryParams) => {
  try {
    await axios.put(API_URLS.updateDictionary, data);
  } catch (error) {
    if (catchCallback) {
      catchCallback();
    }
    if (axios.isAxiosError(error) && error.response?.data?.errors) {
      const errorMessage = parseErrorMessages(error.response.data.errors)[0]
        .message;
      showErrorToast({
        id: errorMessage,
        defaultMessage: errorMessage,
      });
    } else {
      showErrorToast({
        id: "ws_could_not_update_dictionary",
        defaultMessage: "An error occurred while updating the dictionary",
      });
    }
    console.error(error);
  }
};

export const handleUpdatetDictionaryRank = async (data: {
  uuid: string;
  rank: string;
}) => {
  try {
    await axios.post(API_URLS.updateDictionaryRank, {
      wsDictionaryUuid: data.uuid,
      rank: data.rank,
    });
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.data?.errors) {
      const errorMessage = parseErrorMessages(error.response.data.errors)[0]
        .message;
      showErrorToast({
        id: errorMessage,
        defaultMessage: errorMessage,
      });
    } else {
      showErrorToast({
        id: "ws_could_not_update_dictionary",
        defaultMessage: "An error occurred while updating the dictionary",
      });
    }
    console.error(error);
  }
};

export const handleUpdatetDictionaryMetaFieldRank = async (data: {
  uuid: string;
  rank: string;
}) => {
  try {
    await axios.post(API_URLS.updateDictionaryMetaFieldRank, {
      metaFieldUuid: data.uuid,
      rank: data.rank,
    });
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.data?.errors) {
      const errorMessage = parseErrorMessages(error.response.data.errors)[0]
        .message;
      showErrorToast({
        id: errorMessage,
        defaultMessage: errorMessage,
      });
    } else {
      showErrorToast({
        id: "ws_could_not_update_dictionary",
        defaultMessage: "An error occurred while updating the dictionary",
      });
    }
    console.error(error);
  }
};

export const handleUpdatetDictionaryMetaFieldOptions = async (data: {
  uuid: string;
  options: SelectOption[];
}) => {
  try {
    await axios.post(API_URLS.updateDictionaryMetaFieldSelectOptions, {
      metaFieldUuid: data.uuid,
      singleSelectOptions: data.options,
    });
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.data?.errors) {
      const errorMessage = parseErrorMessages(error.response.data.errors)[0]
        .message;
      showErrorToast({
        id: errorMessage,
        defaultMessage: errorMessage,
      });
    } else {
      showErrorToast({
        id: "ws_could_not_update_dictionary",
        defaultMessage: "An error occurred while updating the dictionary",
      });
    }
    console.error(error);
  }
};
